import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'JR',
  name: 'Jorge R.',
  role: '📍 Mendoza | Ingeniero de Minas',
  quote: 'Llevaba 2 años queriendo aprender Leapfrog. Con el MegaPack lo tuve en una semana. El nivel técnico de los cursos es impresionante para el precio que tiene.'
}, {
  initials: 'CP',
  name: 'Carla P.',
  role: '📍 San Juan | Técnica Minera',
  quote: 'El pack de seguridad me salvó en una auditoría interna. Tenía todos los formatos SSOMA listos. Mi jefe no podía creer que lo tuviera todo tan organizado.'
}, {
  initials: 'ML',
  name: 'Marcos L.',
  role: '📍 Jujuy | Supervisor Minero',
  quote: 'Compré el pack un viernes. El lunes ya estaba usando Deswik con los tutoriales incluidos. Nunca imaginé tener acceso a todo esto en pesos argentinos.'
}, {
  initials: 'RS',
  name: 'Rodrigo S.',
  role: '📍 Neuquén | Estudiante de Ingeniería Minera',
  quote: 'Soy estudiante y no podía pagar cursos en dólares. Este pack me dio todo lo que necesito para mi tesis y para empezar a trabajar. Vale 10 veces lo que cuesta.'
}];
export function FullTestimonials() {
  return <section className="py-20 px-4 bg-white" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-16" data-id="element-132">
          Lo que dicen los profesionales mineros{' '}
          <br className="hidden md:block" data-id="element-133" />
          <span className="text-brand-blue" data-id="element-134">que ya tienen su MegaPack:</span>
        </h2>

        <div className="space-y-8" data-id="element-135">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-gray p-8 rounded-2xl shadow-md border border-gray-200" data-id="element-136">
              <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-137">
                <div className="flex-shrink-0 flex flex-col items-center" data-id="element-138">
                  <div className="w-16 h-16 bg-brand-blue text-white rounded-full flex items-center justify-center text-xl font-bold mb-3" data-id="element-139">
                    {t.initials}
                  </div>
                  <div className="flex text-yellow-400" data-id="element-140">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-141" />)}
                  </div>
                </div>
                <div data-id="element-142">
                  <h4 className="text-xl font-bold text-brand-dark mb-1" data-id="element-143">
                    {t.name}
                  </h4>
                  <p className="text-sm text-gray-500 font-medium mb-4" data-id="element-144">
                    {t.role}
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed italic" data-id="element-145">
                    "{t.quote}"
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}